import { render, staticRenderFns } from "./internReferralView.vue?vue&type=template&id=301fd672&scoped=true"
import script from "./internReferralView.vue?vue&type=script&lang=js"
export * from "./internReferralView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301fd672",
  null
  
)

export default component.exports